import React, { useState, useEffect, useRef } from "react";
import "./Coins.css";

import CoinsHeader from "../../components/Sales/CoinsHeader";
import { BsThreeDotsVertical } from "react-icons/bs";
import AddCoinModal from "../../components/Sales/AddCoinModal";
import {
  getCoins,
  addCoin,
  updateCoin,
  toggleCoinStatus,
  deleteCoin,
} from "../../api/coinsApi";

import Pagination from "../../components/MiniComponents/Pagination";
import ConfirmationModal from "../../components/MiniComponents/ConfirmationModal";
import toast from "react-hot-toast";

import useTableQuery from "../../hooks/useTableQuery";

function Coins() {
  const menuRef = useRef(null);

  const [openMenu, setOpenMenu] = useState(null);
  const [data, setData] = useState([]);
  const [viewImage, setViewImage] = useState(null);
  const [editRow, setEditRow] = useState(null);
  const [showAddModal, setShowAddModal] = useState(false);
  const [loading, setLoading] = useState(false);
  const [searchTerm, setSearchTerm] = useState("");
  const [hasNewNotification, setHasNewNotification] = useState(false);
  const [initialLoadDone, setInitialLoadDone] = useState(false);

  const [deleteId, setDeleteId] = useState(null);

  // const [page, setPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);

  const { page, handlePageChange } = useTableQuery();

  const limit = 10;

  const fetchCoins = async () => {
    try {
      setLoading(true);
      const res = await getCoins(page, limit);
      setData(res?.data?.coinsData || []);
      setTotalPages(res?.data?.totalPages || 1);
      setInitialLoadDone(true);
    } catch (err) {
      console.error(err);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchCoins();
  }, [page, limit]);

  const handleToggleStatus = async (coin) => {
    const newStatus = coin.status === "active" ? "inactive" : "active";
    const updated = await toggleCoinStatus(coin._id, newStatus);
    setData((prev) => prev.map((c) => (c._id === coin._id ? updated : c)));
    setOpenMenu(null);
  };

  const handleSaveEdit = async () => {
    const updated = await updateCoin(editRow._id, {
      coinValue: editRow.coinValue,
      price: editRow.price,
      thumbnail: editRow.thumbnail,
    });
    setData((prev) => prev.map((c) => (c._id === updated._id ? updated : c)));
    setEditRow(null);
  };

  const handleDeleteCoin = async () => {
    try {
      const res = await deleteCoin(deleteId);
      console.log("delete coin resp:", res);
      setDeleteId(null);
      toast.success("Coin deleted.");
      fetchCoins();
    } catch (error) {
      console.error("error on delete coins:", error);
      toast.error("Error during delete toast.");
    }
  };

  useEffect(() => {
    const closeMenu = (e) => {
      if (menuRef.current && !menuRef.current.contains(e.target)) {
        setOpenMenu(null);
      }
    };
    document.addEventListener("mousedown", closeMenu);
    return () => document.removeEventListener("mousedown", closeMenu);
  }, []);

  // const filteredData = data.filter(
  //   (item) =>
  //     item.coinValue.toString().includes(searchTerm) ||
  //     item.price.toString().includes(searchTerm) ||
  //     item.status.toLowerCase().includes(searchTerm.toLowerCase()),
  // );

  return (
    <div className="coins-page">
      <div className="coins-content">
        <CoinsHeader
          onAddCoin={() => setShowAddModal(true)}
          searchTerm={searchTerm}
          onSearchChange={setSearchTerm}
          hasNewNotification={hasNewNotification}
          clearNotification={() => setHasNewNotification(false)}
        />

        <div className="coins-card">
          {/* <div className="table-min-width"> */}
          <div className="table-container">
            <div className="table-inner">
              <div className="table-header">
                <div>SRN</div>
                <div>Coins Value</div>
                <div>Price</div>
                {/* <div>Usage</div> */}
                <div>Added At</div>
                {/* <div>Status</div> */}
                <div>Image</div>
                <div className="text-right">Action</div>
              </div>
              <div className="table-body">
                {loading ? (
                  <div className="table-message">Loading lobby data...</div>
                ) : data.length === 0 ? (
                  <div className="table-message">No coins found.</div>
                ) : (
                  data.map((item, index) => (
                    <div key={item._id} className="table-row">
                      <div>{(page - 1) * limit + index + 1}</div>
                      {/* <div>{item.price}</div> */}
                      <div>{item.count}</div>
                      <div>{item.price}</div>
                      <div className="date">
                        {new Date(item.createdAt).toLocaleString()}
                      </div>
                      {/* <div>
                      <span
                        className={`status ${
                          item.status === "active"
                            ? "status-active"
                            : "status-inactive"
                        }`}
                      >
                        {item.status}
                      </span>
                    </div> */}
                      <div>
                        {item.image ? (
                          <button
                            className="view-btn"
                            onClick={() => setViewImage(item.image)}
                          >
                            View
                          </button>
                        ) : (
                          "-"
                        )}
                      </div>

                      <div className="action-cell">
                        <button
                          onClick={() =>
                            setOpenMenu(openMenu === item._id ? null : item._id)
                          }
                        >
                          <BsThreeDotsVertical />
                        </button>

                        {openMenu === item._id && (
                          <div ref={menuRef} className="action-menu">
                            <button
                              onClick={() => {
                                setEditRow(item);
                                setShowAddModal(true);
                                setOpenMenu(null);
                              }}
                            >
                              Edit
                            </button>
                            {/* <button onClick={() => handleToggleStatus(item)}>
                            Toggle Status
                          </button> */}
                            <button onClick={() => setDeleteId(item._id)}>
                              Delete
                            </button>
                          </div>
                        )}
                      </div>
                    </div>
                  ))
                )}
              </div>
              <div
                className="pagination-wrapper"
                // style={{
                //   display: "flex",
                //   justifyContent: "flex-end",
                //   marginRight: "20px",
                //   marginBottom: "10px",
                // }}
              >
                {totalPages > 1 && (
                  <Pagination
                    currentPage={page}
                    totalPages={totalPages}
                    // onPageChange={(p) => setPage(p)}
                    onPageChange={(p) => handlePageChange(p)}
                  />
                )}
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* {editRow && (
        <div className="modal-overlay">
          <div className="modal">
            <h2>Edit Coin</h2>
            <input
              type="number"
              value={editRow.count}
              onChange={(e) =>
                setEditRow({ ...editRow, coinValue: e.target.value })
              }
            />
            <input
              type="number"
              value={editRow.price}
              onChange={(e) =>
                setEditRow({ ...editRow, price: e.target.value })
              }
            />
            <button onClick={handleSaveEdit}>Save</button>
          </div>
        </div>
      )} */}

      {viewImage && (
        <div className="modal-overlay">
          <div className="image-modal">
            <img src={viewImage} alt="coin" />
            <button onClick={() => setViewImage(null)}>Close</button>
          </div>
        </div>
      )}

      {showAddModal && (
        <AddCoinModal
          onClose={() => {
            setShowAddModal(false);
            setEditRow(null);
          }}
          data={editRow}
          onAdd={(coin) => {
            setData((prev) => [...prev, coin]);
            fetchCoins();
            if (initialLoadDone) setHasNewNotification(true);
          }}
        />
      )}

      {deleteId && (
        <ConfirmationModal
          title="Are you sure want to delete this coin."
          onCancel={() => setDeleteId(null)}
          onConfirm={handleDeleteCoin}
        />
      )}
    </div>
  );
}

export default Coins;
